export default {
  data() {
    return {
      sidePanelOpen: true,
      showOpen: false
    }
  },

  methods: {
    showRoute(routeId) {
      this.showOpen = true
      this.selectRoute(routeId, false)
      this.resetSidepanelScroll()
    },

    closeRoute() {
      this.showOpen = false
    },

    changeOpen(newOpen) {
      this.sidePanelOpen = newOpen
    },

    getSublineBackground(subline) {
      return `background-color: ${subline.color}`
    },

    getRouteBusStyle(route) {
      return `--color: ${this.hexToRGB(route.color)}`
    },

    hexToRGB(hex) {
      const [r, g, b] = hex.match(/\w\w/g).map(x => parseInt(x, 16))
      return `${r},${g},${b}`
    },

    selectedClass(routeId) {
      if (routeId === this.selectedRouteId) {
        return 'selected'
      }
      return ''
    },

    selectRoute(routeId, closePanel) {
      if (closePanel && this.$isPortable) {
        this.sidePanelOpen = false
      }

      this.selectedRouteId = routeId
    }
  }
}
